import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { GridComponent } from './components/grid/grid.component';
import { HeroSliderComponent } from './components/hero-slider/hero-slider.component';
import { JoinUsNowComponent } from './components/join-us-now/join-us-now.component';
import { OffersSliderComponent } from './components/offers-slider/offers-slider.component';
import { ProductListingSliderComponent } from './components/product-listing-slider/product-listing-slider.component';
import { HomeComponent } from './home.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from '../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { RecommendProductsSliderComponent } from './components/recommend-products-slider/recommend-products-slider.component';
import { NgxNumberSpinnerModule } from '../ngx-number-spinner/ngx-number-spinner.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ApolloModule } from 'apollo-angular';
import { BrandsComponent } from './components/brands/brands.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedEffects } from '../shared/store/effects/shared.effects';
import * as fromShared from '../shared/store/reducers';
import { SubBannerComponent } from './components/sub-banner/sub-banner.component';

@NgModule({
  declarations: [
    HomeComponent,
    GridComponent,
    HeroSliderComponent,
    JoinUsNowComponent,
    OffersSliderComponent,
    ProductListingSliderComponent,
    RecommendProductsSliderComponent,
    BrandsComponent,
    SubBannerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HomeRoutingModule,
    SlickCarouselModule,
    SharedModule,
    NgSelectModule,
    NgcCookieConsentModule,
    NgxNumberSpinnerModule,
    InfiniteScrollModule,
    ApolloModule,
    StoreModule.forFeature(
      fromShared.sharedFeatureKey,
      fromShared.sharedReducer
    ),
    EffectsModule.forFeature([SharedEffects]),
  ],
})
export class HomeModule {}
